import { Link } from 'react-router-dom';

export default function WikiPageMenu({menu}) {

  return (
    <aside>
      <ul>
        {menu.map((menuitem, index) => (
          <li key={index}>
            <Link to={`/wiki/${menuitem.file}`}>
              {menuitem.title}
            </Link>   
          </li>
        ))}
      </ul>
    </aside>
  );
}
